import moment from 'moment';

import * as DateUtil from 'util/DateUtil';

export const CREATE_ANALYSIS_NO_PERMISSION_MESSAGE =
  'You do not have sufficient permissions to create an analysis. Please contact your administrator.';

/**
 * Returns the initial analysis name to use in the create analysis modal for analysis of a study.
 *
 * @param studyName The name of the study.
 */
export function getInitialAnalysisNameForStudy(studyName: string): string {
  return `${studyName}_${DateUtil.readableTime(moment(), {
    showTime: true,
  })}`;
}
